export const AI_WALLET_REFRESH_EVENT = "rcm-ai-wallet-refresh";

export function notifyAiWalletRefresh(): void {
  window.dispatchEvent(new CustomEvent(AI_WALLET_REFRESH_EVENT));
}
